import * as dashboardService from '../../services/dashboardService';
import dashboardActionConstants from '../constants/dashboardActionConstants';

export function getActivityList(params) {
  return (dispatch) => {
    dispatch({
      type: dashboardActionConstants.GET_ACTIVITY_LIST,
      payload: {
        isPagination: Boolean(params && params.offset),
      },
    });
    dashboardService
      .getActivityList(params)
      .then((response) => {
        const isPagination = Boolean(params && params.offset);
        const { activities } = response.data.payload;
        dispatch({
          type: dashboardActionConstants.GET_ACTIVITY_LIST_SUCCESS,
          payload: {
            activities,
            isPagination,
          },
        });
      })
      .catch(() => {
        dispatch({ type: dashboardActionConstants.GET_ACTIVITY_LIST_ERROR });
      });
  };
}

export function likeActivity(activityId) {
  return (dispatch) => {
    dispatch({
      type: dashboardActionConstants.LIKE_ACTIVITY,
      payload: activityId,
    });
    dashboardService
      .likeActivity(activityId)
      .then(() => {
        dispatch({
          type: dashboardActionConstants.LIKE_ACTIVITY_SUCCESS,
          payload: activityId,
        });
      })
      .catch(() => {
        dispatch({ type: dashboardActionConstants.LIKE_ACTIVITY_ERROR, payload: activityId });
      });
  };
}

export function unlikeActivity(activityId) {
  return (dispatch) => {
    dispatch({
      type: dashboardActionConstants.UNLIKE_ACTIVITY,
      payload: activityId,
    });
    dashboardService
      .unlikeActivity(activityId)
      .then(() => {
        dispatch({
          type: dashboardActionConstants.UNLIKE_ACTIVITY_SUCCESS,
          payload: activityId,
        });
      })
      .catch(() => {
        dispatch({ type: dashboardActionConstants.UNLIKE_ACTIVITY_ERROR, payload: activityId });
      });
  };
}

export function getLeaderBoardList(params) {
  return (dispatch) => {
    dispatch({ type: dashboardActionConstants.GET_LEADER_BOARD_LIST });
    dashboardService
      .getLeaderBoardList(params)
      .then((response) => {
        dispatch({
          type: dashboardActionConstants.GET_LEADER_BOARD_LIST_SUCCESS,
          payload: response.data.payload,
        });
      })
      .catch(() => {
        dispatch({ type: dashboardActionConstants.GET_LEADER_BOARD_LIST_ERROR });
      });
  };
}

export function getTermsAndConditions(organizationId) {
  return (dispatch) => {
    dispatch({ type: dashboardActionConstants.GET_REWARDS_TERMS_AND_CONDITIONS });
    dashboardService
      .getTermsAndConditions(organizationId)
      .then((response) => {
        dispatch({
          type: dashboardActionConstants.GET_REWARDS_TERMS_AND_CONDITIONS_SUCCESS,
          payload: response.data.payload,
        });
      })
      .catch(() => {
        dispatch({ type: dashboardActionConstants.GET_REWARDS_TERMS_AND_CONDITIONS_ERROR });
      });
  };
}

export function getHotJobs(params) {
  return (dispatch) => {
    dispatch({ type: dashboardActionConstants.GET_HOT_JOBS });
    dashboardService
      .getHotJobs(params)
      .then((response) => {
        dispatch({ type: dashboardActionConstants.GET_HOT_JOBS_SUCCESS, payload: response.data.payload });
      })
      .catch(() => {
        dispatch({ type: dashboardActionConstants.GET_HOT_JOBS_ERROR });
      });
  };
}

export function getRecommendedJobs(params) {
  return (dispatch) => {
    dispatch({ type: dashboardActionConstants.GET_RECOMMENDED_JOBS });
    dashboardService
      .getRecommendedJobs(params)
      .then((response) => {
        dispatch({ type: dashboardActionConstants.GET_RECOMMENDED_JOBS_SUCCESS, payload: response.data.payload });
      })
      .catch(() => {
        dispatch({ type: dashboardActionConstants.GET_RECOMMENDED_JOBS_ERROR });
      });
  };
}

function transformMatchToRecommendation(match) {
  const { contact, job, matching_score, matching_reason } = match;
  return {
    id: `${contact?.id}-${job?.id}`,
    person_name: contact?.full_name,
    match_score: matching_score,
    matching_reason,
    contact_job_title: contact?.job_title,
    contact_company: contact?.company,
    contact_location: contact?.location,
    contact_id: contact?.user_contact_id,
    job_uuid: job?.uuid,
    job_referral_link: null,
    job_data: job
      ? {
          id: job.id,
          uuid: job.uuid,
          title: job.title,
          organization_name: job.company_name,
          job_location: job.location,
          work_type: job.work_type,
          work_place_type: job.work_place_type,
          category: job.category,
          external_job_link: job.external_job_link,
          published_date: job.created_at ? new Date(job.created_at * 1000).toISOString() : null,
          skills: job.skills,
          job_experience_name: job.job_experience,
        }
      : null,
  };
}

export function getReferralRecommendations(params) {
  return (dispatch) => {
    dispatch({ type: dashboardActionConstants.GET_REFERRAL_RECOMMENDATIONS });

    dashboardService
      .getReferralRecommendations({ limit: params.limit, offset: params.offset })
      .then((response) => {
        const { payload } = response.data;
        const matches = payload.matches || [];
        dispatch({
          type: dashboardActionConstants.GET_REFERRAL_RECOMMENDATIONS_SUCCESS,
          payload: {
            recommendations: matches.map(transformMatchToRecommendation),
            total_count: payload.total_matches || matches.length,
          },
        });
      })
      .catch(() => {
        dispatch({ type: dashboardActionConstants.GET_REFERRAL_RECOMMENDATIONS_ERROR });
      });
  };
}

export function getReferralLink(params, isIOSDevice) {
  return (dispatch) => {
    dispatch({ type: dashboardActionConstants.GET_REFERRAL_LINK });
    dashboardService
      .getReferralLink(params)
      .then((response) => {
        dispatch({ type: dashboardActionConstants.GET_REFERRAL_LINK_SUCCESS, payload: response.data.payload });
        if (isIOSDevice) {
          window.location.href = response.data.payload;
        } else {
          window.open(response.data.payload, '_blank');
        }
      })
      .catch(() => {
        dispatch({ type: dashboardActionConstants.GET_REFERRAL_LINK_ERROR });
      });
  };
}
